<template>
  <v-dialog v-model="store.loading" persistent max-width="300" height="300">
    <v-card
      color="transparent"
      elevation="0"
      class="d-flex justify-center align-center"
      style="background: transparent"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        size="64"
      ></v-progress-circular>
    </v-card>
  </v-dialog>
</template>

<script setup>
  const store = window.useGlobalStore();
</script>